import type { DexesList } from './types';

/**
 * Stand-in data for the DEX Exchanges page: the DEX backend has no endpoint that
 * returns the full exchange configuration yet.
 *
 * TODO(SKY-2783): drop this mock once the exchanges list page gets its endpoint.
 */
export const mockDexExchanges: DexesList[] = [
  {
    id: 1,
    name: 'Uniswap',
    service: 0,
    protocol: 'V3',
    b_id: 1,
    factory: '0x1F98431c8aD98523631AE4a59f267346ea31F984',
    router: '0xE592427A0AEce92De3Edee1F18E0157C05861564',
    quoter: '0xb27308f9F90D607463bb33eA1BeBb41C27CE5AB6',
    nft_manager: '0xC36442b4a4522E871399CD717aBDD847Ab11FE88',
    pool_deployer: null,
    initCode: 'e34f199b19b2b4f47f68442619d555527d244f78a3297ea89325f843f87b8b54',
    fee: '0.05, 0.3, 1.0',
    trade_native: 1,
    contract_template: 'uniswap_v3_template',
    active: 1,
  },
  {
    id: 2,
    name: 'PancakeSwap',
    service: 0,
    protocol: 'V2',
    b_id: 56,
    factory: '0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73',
    router: '0x10ED43C718714eb63d5aA57B78B54704E256024E',
    quoter: null,
    nft_manager: null,
    pool_deployer: null,
    initCode: '00fb7f630766e6a796048ea87d01acd3068e8ff67d078148a3fa3f4a84f69bd5',
    fee: '0.25',
    trade_native: 1,
    contract_template: 'pancake_v2_template',
    active: 1,
  },
  {
    id: 3,
    name: '1inch Aggregator',
    service: 1,
    protocol: 'V5',
    b_id: 1,
    factory: undefined,
    router: '0x1111111254EEB25477B68fb85Ed929f73A960582',
    quoter: undefined,
    nft_manager: undefined,
    pool_deployer: undefined,
    initCode: undefined,
    fee: null,
    trade_native: 1,
    contract_template: 'aggregator_template',
    active: 1,
  },
  {
    id: 4,
    name: 'SushiSwap',
    service: 0,
    protocol: 'V2',
    b_id: 1,
    factory: '0xC0AEe478e3658e2610c5F7A4A2E1777cE9e4f2Ac',
    router: '0xd9e1cE17f2641f24aE83637ab66a2cca9C378B9F',
    quoter: null,
    nft_manager: null,
    pool_deployer: null,
    initCode: 'e18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303',
    fee: '0.3',
    trade_native: 1,
    contract_template: 'sushi_v2_template',
    active: 1,
  },
  {
    id: 5,
    name: 'Curve Finance',
    service: 0,
    protocol: 'V1',
    b_id: 1,
    factory: '0x0959158b6040D32d04c301A72CBFD6b39E21c9AE',
    router: '0x99a58482BD75cbab83b27EC03CA68fF489b5788f',
    quoter: undefined,
    nft_manager: undefined,
    pool_deployer: undefined,
    initCode: undefined,
    fee: null,
    trade_native: 0,
    contract_template: 'curve_template',
    active: 0,
  },
];
